import type { ErrorComponentProps as TanStackErrorComponentProps } from '@tanstack/react-router'
import { useEffect } from 'react'
import AppIcon from '@/images/app-icon.png?url'
import * as Sentry from '@sentry/tanstackstart-react'
import { useRouter } from '@tanstack/react-router'

import { Button } from './ui/button'

type ErrorComponentProps = TanStackErrorComponentProps

function ErrorComponent({ error, reset }: ErrorComponentProps) {
  const router = useRouter()

  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <div className="flex h-dvh w-full flex-col">
      <main className="flex flex-1 flex-col items-center justify-center">
        <img
          src={AppIcon}
          alt="App Icon"
          className="mb-6 h-32 w-32 grayscale-80 invert-75"
        />
        <h1 className="mb-1 text-center text-xl font-semibold">
          Oops! An error occurred.
        </h1>
        <pre className="no-scrollbar text-destructive mb-4 max-h-40 max-w-sm overflow-auto rounded-lg p-2 text-center font-mono text-xs whitespace-pre-wrap">
          {JSON.stringify({ error: error.message })}
        </pre>
        <Button
          onClick={() => {
            reset()
            router.invalidate()
          }}
          type="button"
          size="sm"
          variant="secondary"
        >
          Try again
        </Button>
      </main>
      <footer className="flex items-center justify-center py-6">
        <p className="text-muted-foreground mx-auto text-center text-xs">
          &copy; {new Date().getFullYear()}
        </p>
      </footer>
    </div>
  )
}

export default Sentry.withErrorBoundary(ErrorComponent, {})
